<main role="main">
  <h1 class="aria-offscreen">{{headerText}}</h1>
  <div
    *ngIf="contentFragment"
    [innerHTML]="contentFragment | safe"
    id="contentFragment"
    [className]="darkSiteLevel"
  ></div>
</main>
